import * as types from './actionTypes';
import client from 'helpers/client';
import cognito from 'helpers/cognito';
import store from 'redux/store';

export const getCredits = (email) => {
  return async (dispatch) => {
    dispatch({ type: types.GET_CREDITS });

    client
      .api(`/credit/user-get-credits?email=${email}`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then((res) => {
        dispatch({
          type: types.GET_CREDITS_SUCCESS,
          data: res.data.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: types.GET_CREDITS_FAILED,
          reason: err,
        });
      });
  };
};

export const getCreditsHistory = (limit, page) => {
  return async (dispatch) => {
    const credit = store.getState().credit;
    const { history, pagination } = credit;
    if (pagination.page === page) return;
    dispatch({ type: types.GET_CREDITS_HISTORY });

    client
      .api(`/credit/user-get-credits-history?limit=${limit}&page=${page}`, 'get', {
        headers: await cognito.getHeaderAuthorization(),
      })
      .then(({ data }) => {
        dispatch({
          type: types.GET_CREDITS_HISTORY_SUCCESS,
          data: {
            history: [...history, ...data.data],
            pagination: data.pagination,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: types.GET_CREDITS_HISTORY_FAILED,
          reason: err,
        });
      });
  };
};
